import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the KarmaMilesPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'karmaMiles',
})
export class KarmaMilesPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    if (args[0] === 'short') {
      return _.padStart(value || '', 5, '0');
    } else {
      return _.padStart(value || '', 9, '0');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/karma-miles/karma-miles.ts